import { z } from 'zod/v4';

export const isValidUrl = (urlString: string) => {
  try {
    const url = new URL(urlString);

    const hostname = url.hostname;

    const isIpAddr = isIp(hostname);

    // Only http/https
    if (!['http:', 'https:'].includes(url.protocol)) {
      return false;
    }

    if (!isIpAddr) {
      // Reject localhost or single-word hostnames
      if (hostname === 'localhost' || !hostname.includes('.')) {
        return false;
      }

      // Domain name check
      const parts = hostname.split('.');
      const tld = parts[parts.length - 1];

      // Top-level domain must be at least 2 letters (e.g. .com, .org, .uk, etc)
      if (tld.length < 2 || !/^[a-z]+$/i.test(tld)) {
        return false;
      }

      return true;
    }

    return isIpAddr;
  } catch {
    return false;
  }
};

const isIp = (ipString: string) => {
  const normalizedIpString = ipString.replace('[', '').replace(']', '');
  return (
    z.ipv4().safeParse(normalizedIpString).success ||
    z.ipv6().safeParse(normalizedIpString).success
  );
};
